import { Entity, PrimaryKey, Property, ManyToOne } from '@mikro-orm/core';
import { User } from '../../user/entities/user.entity';

@Entity()
export class File {
  @PrimaryKey({ autoincrement: true })
  id!: number;

  @Property()
  url!: string;

  @ManyToOne(() => User)
  user!: User;

  @Property({nullable: true})
  module: string;

  @Property({nullable: true})
  module_id: number | null;

  @Property({nullable: true})
  mime_type: string;

  @Property()
  created_at: Date = new Date();

  @Property({ onUpdate: () => new Date() })
  updated_at: Date = new Date();

  @Property({ nullable: true })
  deleted_at?: Date;
}
